async function devtricker_updateThumbnailMetadata(postId, caption, thumbDisplayPosition) {
    const formData = new FormData();
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('post_id', postId);
    formData.append('action', 'devtricker_update_thumbnail_metadata');
    formData.append('caption', caption);
    formData.append('thumb_display_position', thumbDisplayPosition);

    const updateUrl = '/wp-admin/admin-ajax.php';

    const response = await fetch(updateUrl, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const result = await response.json();

    console.log("Resultado: " + JSON.stringify(result));

    if (result.success) {
        console.log('Metadata update successful:', JSON.stringify(result));
        return result.data;
    } else {
        console.error('Error from server:', result.data);
        throw new Error(result.data.message || 'Error updating the metadata');
    }
}